var data = [{
  type: 'standard',
  name: '标准版会员',
  applicable: '推荐个人使用',
  price: 99,
  originPrice: 199,
  menuList: [{
    name: '首页',
    children: [{
      name: '一张图（部分功能）'
    }]
  }, {
    name: '实时监测',
    children: [{
      name: '天气实况'
    }, {
      name: '台风监测'
    }, {
      name: '卫星云图'
    }, {
      name: '气象雷达'
    }]
  }, {
    name: '预报预警',
    children: [{
      name: '数值预报（仅风场预报）'
    }, {
      name: '24h、48h、72h降雨预报'
    }, {
      name: '风场'
    }]
  }, {
    name: '辅助分析',
    children: [{
      name: '专家分析'
    }]
  }, {
    name: '客服支持',
    children: [{
      name: '微信客服'
    }]
  }]
}, {
  type: 'speciality',
  name: '专业版会员',
  applicable: '推荐中小企业及专业爱好者使用',
  price: 299,
  originPrice: 599,
  menuList: [{
    name: '首页',
    children: [{
      name: '一张图（部分功能）'
    }]
  }, {
    name: '实时监测',
    children: [{
      name: '天气实况'
    }, {
      name: '台风监测'
    }, {
      name: '卫星云图'
    }, {
      name: '气象雷达'
    }, {
      name: '地震速报'
    }]
  }, {
    name: '预报预警',
    children: [{
      name: '数值预报（包含风场、阵风、浪场、温度、水汽含量、相对湿度、位势高度、海平面气压）'
    }, {
      name: '24h、48h、72h降雨预报'
    }, {
      name: '风场'
    }, {
      name: '浪场'
    }, {
      name: '副热带高压图'
    }]
  }, {
    name: '辅助分析',
    children: [{
      name: '专家分析'
    }, {
      name: '气象资料'
    }]
  }, {
    name: '客服支持',
    children: [{
      name: '微信客服'
    }]
  }]
}, {
  type: 'enjoy',
  name: '尊享版会员',
  applicable: '自定义实时预警满足更多需求',
  price: 599,
  originPrice: 1099,
  menuList: [{
    name: '首页',
    children: [{
      name: '一张图（部分功能）'
    }]
  }, {
    name: '实时监测',
    children: [{
      name: '天气实况'
    }, {
      name: '台风监测'
    }, {
      name: '卫星云图'
    }, {
      name: '气象雷达'
    }, {
      name: '地震速报'
    }]
  }, {
    name: '预报预警',
    children: [{
      name: '数值预报（包含风场、阵风、浪场、温度、水汽含量、相对湿度、位势高度、海平面气压）'
    }, {
      name: '实时预警（台风影响预警、气象灾害预警、要素阈值预警）'
    }, {
      name: '近海预报'
    }, {
      name: '近岸预报'
    }, {
      name: '24h、48h、72h降雨预报'
    }, {
      name: '风场'
    }, {
      name: '浪场'
    }, {
      name: '副热带高压图'
    }]
  }, {
    name: '辅助分析',
    children: [{
      name: '台风检索'
    }, {
      name: '专家分析'
    }, {
      name: '气象资料'
    }]
  }, {
    name: '场景服务',
    children: [{
      name: '海上救援'
    }]
  }, {
    name: '预警提醒',
    children: [{
      name: '短信、钉钉、企业微信'
    }]
  }, {
    name: '客服支持',
    children: [{
      name: '微信客服'
    }]
  }]
}, {
  type: 'customized',
  name: '定制平台',
  applicable: '适用于有定制开发需求的大客户',
  price: '自由组合功能模块',
  originPrice: '可针对使用场景定制开发相应功能，我们将为您提供一对一的专业服务',
  menuList: [{
    name: '实时监测',
    children: [{
      name: '火情监测'
    }, {
      name: '降雨监测'
    }, {
      name: '水情监测'
    }, {
      name: '实况影像'
    }, {
      name: '海洋监测'
    }]
  }, {
    name: '预报预警',
    children: [{
      name: '短临预报'
    }, {
      name: '精细化降雨预报'
    }]
  }, {
    name: '辅助分析',
    children: [{
      name: '台风分析'
    }]
  }, {
    name: '场景服务',
    children: [{
      name: '多灾种应急决策'
    }, {
      name: '海上风电自然风险保障'
    }, {
      name: '海上工程作业风险保障'
    }, {
      name: '基层防汛指挥场景'
    }, {
      name: '森林防火监测指挥'
    }]
  }, {
    name: '客服支持',
    children: [{
      name: '一对一专业客服'
    }]
  }]
}];
export default data;